export enum RectangleSkeletonVariant {
  Default = "rectangleDefault",
  Pill = "rectanglePill",
}

export interface RectangleSkeletonProps {
  width?: number | string;
  height?: number | string;
  gap?: number;
  borderRadius?: number | string;
  className?: string;
  variant?: RectangleSkeletonVariant;
}

export interface CircleSkeletonProps {
  diameter?: number | string;
  marginBottom?: number;
  className?: string;
}

export interface MultilineTextSkeletonProps {
  lines?: number;
  width?: number | string;
  height?: number | string;
  className?: string;
}
